<template>
  <div class="wrapper">
    <notifications position="bottom right" />
    <Sidebar v-if="!$route.meta.hideSidebar" />
    <Navbar v-if="!$route.meta.hideNavbar" />
    <router-view v-slot="{ Component, route }">
      <transition name="route" mode="out-in">
        <div :key="route.name">
          <component :is="Component"></component>
        </div>
      </transition>
    </router-view>
  </div>
</template>

<script>
import Sidebar from "@/components/Sidebar.vue";
import Navbar from "@/components/Navbar.vue";

export default {
  components: { Sidebar, Navbar },
  name: "app",
  data() {
    return {};
  },
  mounted() { },
};
</script>

<style lang="scss">
@keyframes resizeSensorVisibility {
  0% {
    top: 0;
  }
}



html {
  font-size: 62.5%;
}


.textLayer {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  opacity: 0.2;
  line-height: 1;
}

.textLayer>span {
  color: transparent;
  position: absolute;
  white-space: pre;
  cursor: text;
  transform-origin: 0 0;
}

.textLayer .highlight {
  margin: -1px;
  padding: 1px;
  background-color: #b400aa;
  border-radius: 4px;
}

.textLayer .highlight.begin {
  border-radius: 4px 0 0 4px;
}

.textLayer .highlight.end {
  border-radius: 0 4px 4px 0;
}

.textLayer .highlight.middle {
  border-radius: 0;
}

.textLayer .highlight.selected {
  background-color: #006400;
}

.textLayer ::-moz-selection {
  background: #00f;
}

.textLayer ::selection {
  background: #00f;
}

.textLayer .endOfContent {
  display: block;
  position: absolute;
  left: 0;
  top: 100%;
  right: 0;
  bottom: 0;
  z-index: -1;
  cursor: default;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.textLayer .endOfContent.active {
  top: 0;
}

.annotationLayer section {
  position: absolute;
}

.annotationLayer .buttonWidgetAnnotation.pushButton>a,
.annotationLayer .linkAnnotation>a {
  position: absolute;
  font-size: 1em;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.annotationLayer .buttonWidgetAnnotation.pushButton>a:hover,
.annotationLayer .linkAnnotation>a:hover {
  opacity: 0.2;
  background: #ff0;
  box-shadow: 0 2px 10px #ff0;
}

.annotationLayer .textAnnotation img {
  position: absolute;
  cursor: pointer;
}

.annotationLayer .buttonWidgetAnnotation.checkBox input,
.annotationLayer .buttonWidgetAnnotation.radioButton input,
.annotationLayer .choiceWidgetAnnotation select,
.annotationLayer .textWidgetAnnotation input,
.annotationLayer .textWidgetAnnotation textarea {
  background-color: rgba(0, 54, 255, 0.13);
  border: 1px solid transparent;
  box-sizing: border-box;
  font-size: 9px;
  height: 100%;
  margin: 0;
  padding: 0 3px;
  vertical-align: top;
  width: 100%;
}

.annotationLayer .choiceWidgetAnnotation select option {
  padding: 0;
}

.annotationLayer .buttonWidgetAnnotation.radioButton input {
  border-radius: 50%;
}

.annotationLayer .textWidgetAnnotation textarea {
  font: message-box;
  font-size: 9px;
  resize: none;
}

.annotationLayer .buttonWidgetAnnotation.checkBox input[disabled],
.annotationLayer .buttonWidgetAnnotation.radioButton input[disabled],
.annotationLayer .choiceWidgetAnnotation select[disabled],
.annotationLayer .textWidgetAnnotation input[disabled],
.annotationLayer .textWidgetAnnotation textarea[disabled] {
  background: none;
  border: 1px solid transparent;
  cursor: not-allowed;
}

.annotationLayer .buttonWidgetAnnotation.checkBox input:hover,
.annotationLayer .buttonWidgetAnnotation.radioButton input:hover,
.annotationLayer .choiceWidgetAnnotation select:hover,
.annotationLayer .textWidgetAnnotation input:hover,
.annotationLayer .textWidgetAnnotation textarea:hover {
  border: 1px solid #000;
}

.annotationLayer .choiceWidgetAnnotation select:focus,
.annotationLayer .textWidgetAnnotation input:focus,
.annotationLayer .textWidgetAnnotation textarea:focus {
  background: none;
  border: 1px solid transparent;
}

.annotationLayer .buttonWidgetAnnotation.checkBox input:checked:after,
.annotationLayer .buttonWidgetAnnotation.checkBox input:checked:before,
.annotationLayer .buttonWidgetAnnotation.radioButton input:checked:before {
  background-color: #000;
  content: "";
  display: block;
  position: absolute;
}

.annotationLayer .buttonWidgetAnnotation.checkBox input:checked:after,
.annotationLayer .buttonWidgetAnnotation.checkBox input:checked:before {
  height: 80%;
  left: 45%;
  width: 1px;
}

.annotationLayer .buttonWidgetAnnotation.checkBox input:checked:before {
  transform: rotate(45deg);
}

.annotationLayer .buttonWidgetAnnotation.checkBox input:checked:after {
  transform: rotate(-45deg);
}

.annotationLayer .buttonWidgetAnnotation.radioButton input:checked:before {
  border-radius: 50%;
  height: 50%;
  left: 30%;
  top: 20%;
  width: 50%;
}

.annotationLayer .textWidgetAnnotation input.comb {
  font-family: monospace;
  padding-left: 2px;
  padding-right: 0;
}

.annotationLayer .textWidgetAnnotation input.comb:focus {
  width: 115%;
}

.annotationLayer .buttonWidgetAnnotation.checkBox input,
.annotationLayer .buttonWidgetAnnotation.radioButton input {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 0;
}

.annotationLayer .popupWrapper {
  position: absolute;
  width: 20em;
}

.annotationLayer .popup {
  position: absolute;
  z-index: 200;
  max-width: 20em;
  background-color: #ff9;
  box-shadow: 0 2px 5px #888;
  border-radius: 2px;
  padding: 6px;
  margin-left: 5px;
  cursor: pointer;
  font: message-box;
  font-size: 9px;
  word-wrap: break-word;
}

.annotationLayer .popup>* {
  font-size: 9px;
}

.annotationLayer .popup h1 {
  display: inline-block;
}

.annotationLayer .popup span {
  display: inline-block;
  margin-left: 5px;
}

.annotationLayer .popup p {
  border-top: 1px solid #333;
  margin-top: 2px;
  padding-top: 2px;
}

.annotationLayer .caretAnnotation,
.annotationLayer .circleAnnotation svg ellipse,
.annotationLayer .fileAttachmentAnnotation,
.annotationLayer .freeTextAnnotation,
.annotationLayer .highlightAnnotation,
.annotationLayer .inkAnnotation svg polyline,
.annotationLayer .lineAnnotation svg line,
.annotationLayer .polygonAnnotation svg polygon,
.annotationLayer .polylineAnnotation svg polyline,
.annotationLayer .squareAnnotation svg rect,
.annotationLayer .squigglyAnnotation,
.annotationLayer .stampAnnotation,
.annotationLayer .strikeoutAnnotation,
.annotationLayer .underlineAnnotation {
  cursor: pointer;
}

.pdfViewer .canvasWrapper {
  overflow: hidden;
}

.pdfViewer .page {
  direction: ltr;
  width: 816px;
  height: 1056px;
  margin: 1px auto -8px auto;
  position: relative;
  overflow: visible;
  border: 9px solid transparent;
  background-clip: content-box;
  -o-border-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAQAAADYWf5HAAAA6UlEQVR4Xl2Pi2rEMAwE16fm1f7/r14v7w4rI0IzLAF7hLxNevBSEMEF5+OilNCsRd8ZMyn+a4NmsOT8WJw1lFbSYgGFzF2bLFoLjTClWjKKGRWpDYAGXUnZ4uhbBUzF3Oe/GG/ue2fn4GgsyXhNgysV2JnrhKEMg4fEZcALmiKbNhBBRFpSyDOj1G4QOVly6O1FV54ZZq8OVygrciDt6JazRgi1ljTPH0gbrPmHPXAbCiDd4GawIjip1TPh9tt2sz24qaCjr/jAb/GBFTbq9KZ7Ke/Cqt8nayUikZKsWZK7Fe6bg5dOUt8fZHWG2BHc+6EAAAAASUVORK5CYII=) 9 9 repeat;
  border-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAQAAADYWf5HAAAA6UlEQVR4Xl2Pi2rEMAwE16fm1f7/r14v7w4rI0IzLAF7hLxNevBSEMEF5+OilNCsRd8ZMyn+a4NmsOT8WJw1lFbSYgGFzF2bLFoLjTClWjKKGRWpDYAGXUnZ4uhbBUzF3Oe/GG/ue2fn4GgsyXhNgysV2JnrhKEMg4fEZcALmiKbNhBBRFpSyDOj1G4QOVly6O1FV54ZZq8OVygrciDt6JazRgi1ljTPH0gbrPmHPXAbCiDd4GawIjip1TPh9tt2sz24qaCjr/jAb/GBFTbq9KZ7Ke/Cqt8nayUikZKsWZK7Fe6bg5dOUt8fZHWG2BHc+6EAAAAASUVORK5CYII=) 9 9 repeat;
  background-color: #fff;
}

.pdfViewer.removePageBorders .page {
  margin: 0 auto 10px auto;
  border: none;
}

.pdfViewer.singlePageView {
  display: inline-block;
}

.pdfViewer.singlePageView .page {
  margin: 0;
  border: none;
}

.pdfViewer.scrollHorizontal,
.pdfViewer.scrollWrapped,
.spread {
  margin-left: 3.5px;
  margin-right: 3.5px;
  text-align: center;
}

.pdfViewer.scrollHorizontal,
.spread {
  white-space: nowrap;
}

.pdfViewer.removePageBorders,
.pdfViewer.scrollHorizontal .spread,
.pdfViewer.scrollWrapped .spread {
  margin-left: 0;
  margin-right: 0;
}

.pdfViewer.scrollHorizontal .page,
.pdfViewer.scrollHorizontal .spread,
.pdfViewer.scrollWrapped .page,
.pdfViewer.scrollWrapped .spread,
.spread .page {
  display: inline-block;
  vertical-align: middle;
}

.pdfViewer.scrollHorizontal .page,
.pdfViewer.scrollWrapped .page,
.spread .page {
  margin-left: -3.5px;
  margin-right: -3.5px;
}

.pdfViewer.removePageBorders.scrollHorizontal .page,
.pdfViewer.removePageBorders.scrollWrapped .page,
.pdfViewer.removePageBorders .spread .page {
  margin-left: 5px;
  margin-right: 5px;
}

.pdfViewer .page canvas {
  margin: 0;
  display: block;
}

.pdfViewer .page canvas[hidden] {
  display: none;
}

.pdfViewer .page .loadingIcon {
  position: absolute;
  display: block;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: url(data:image/gif;base64,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) 50% no-repeat;
}

.pdfPresentationMode .pdfViewer {
  margin-left: 0;
  margin-right: 0;
}

.pdfPresentationMode .pdfViewer .page,
.pdfPresentationMode .pdfViewer .spread {
  display: block;
}

.pdfPresentationMode .pdfViewer .page,
.pdfPresentationMode .pdfViewer.removePageBorders .page {
  margin-left: auto;
  margin-right: auto;
}

.pdfPresentationMode:-ms-fullscreen .pdfViewer .page {
  margin-bottom: 100% !important;
}

.pdfPresentationMode:-webkit-full-screen .pdfViewer .page {
  margin-bottom: 100%;
  border: 0;
}

.pdfPresentationMode:-moz-full-screen .pdfViewer .page {
  margin-bottom: 100%;
  border: 0;
}

.pdfPresentationMode:fullscreen .pdfViewer .page {
  margin-bottom: 100%;
  border: 0;
}

// DOCUMENT/BODY STYLING
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "Neue Haas Grotesk Display Pro", sans-serif;
  background-color: var(--bg-color);
  color: var(--standard-color);
  transition: background-color 0.3s ease;
  // overflow-y: scroll;
}

.body-login {
  overflow: hidden;
}

// APP STYLING
#app {
  height: 100vh;
}

// HTML ELEMENTS
// button {
//   cursor: pointer;
//   font-family: "Neutrif-bold";
// }

// input {
//   color: var(--primary-text-color);
//   font-family: "Neutrif-reg";
// }

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px white inset !important;
  box-shadow: 0 0 0 30px white inset !important;
}

input:-webkit-autofill {
  font-family: "Neutrif-reg";
  -webkit-text-fill-color: --primary-text-color !important;
}

input::placeholder {
  color: #d7dce1;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin-bottom: 10px;
  margin-top: 0;
}

h1 {
  font-size: 2.8rem;
}

h2 {
  font-size: 2.4rem;
  margin: 0;
}

h3 {
  font-size: 21px;
}

h4 {
  font-size: 16px;
}

b,
strong,
.strong {
  font-weight: 600;
}

a {
  text-decoration: none;
}

// VFM
.vfm__content {
  width: fit-content;
}

.vfm__overlay {
  background: rgba(46, 48, 63, 0.5) !important;
}

#viewerContainer .page {
  width: auto !important;
  height: auto !important;
}

#viewerContainer .page .canvasWrapper {
  width: auto !important;
  height: auto !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

#viewerContainer .page .textLayer {
  width: auto !important;
  height: auto !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

#viewerContainer canvas {
  max-height: 440px !important;
  width: auto !important;
  max-width: 440px !important;
}

// ROUTE TRANSITION
.route-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.route-enter-active {
  transition: all 0.3s ease-out;
}

.route-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

.route-leave-active {
  transition: all 0.3s ease-in;
}

// FADE TRANSITION
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

// KEYFRAMES
@keyframes pulse-bg {
  0% {
    background-color: #ddd;
  }

  50% {
    background-color: #d0d0d0;
  }

  100% {
    background-color: #ddd;
  }
}

@keyframes pulse-bg-dark {
  0% {
    background-color: #393b4d;
  }

  50% {
    background-color: #4d4f63;
  }

  100% {
    background-color: #393b4d;
  }
}

// NAV + SIDEBAR GLOBAL
.sidebar.close~nav {
  left: 70px;
  width: calc(100% - 70px);
}

nav {
  position: relative;
  width: calc(100% - 240px);
  height: 100vh;
  left: 240px;
}

// PAGEHEADER
.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 2rem;

  .title-wrapper {
    .title {
      font-size: 32px;
      font-family: "Neutrif-bold";
      padding-bottom: 0.25rem;
    }

    .subtitle {
      font-size: 16px;
      color: #9397a1;
    }
  }

  .datepicker {
    position: relative;

    .button {
      font-family: "Neutrif-bold";
      color: #0b212d;
      font-size: 16px;
      background: white;
      height: 40px;
      padding: 0 1rem;
      border-radius: $border-radius;
      cursor: pointer;
      transition: all 0.3s ease;
      border: 1px solid transparent;
      display: flex;
      align-items: center;
      border: 1px solid #d7dce1;

      &:hover {
        box-shadow: 3px 3px 30px rgba(0, 0, 0, 0.15);
      }

      p {
        display: inline;
        margin-right: 0.5rem;
      }

      .arrow {
        font-size: 20px;
        transition: transform 0.3s ease;
      }

      .open {
        transform: rotate(180deg);
      }
    }

    .button.active {
      box-shadow: 3px 3px 30px rgba(0, 0, 0, 0.15);
    }

    .dropdown {
      position: absolute;
      font-size: 18px;
      background: white;
      margin-top: 1rem;
      border-radius: $border-radius;
      display: block;
      width: 20rem;
      transform: scale(0.01);
      opacity: 0;
      transition: transform 0.3s ease, opacity 0.3s ease, box-shadow 0.3s ease 0.15s;
      transform-origin: right top;
      overflow: hidden;
      z-index: 2;
      right: 0;

      .datepicker-card {
        width: 20rem;
        background-color: #2e303f;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: column;
        padding: 1.25rem 2rem;

        .title {
          font-family: "Neutrif-bold";
          color: white;
        }

        .subtitle {
          font-size: 16px;
          color: #9397a1;
        }
      }

      .datepicker-presets {
        padding: 1.25rem 2rem;

        a {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 16px;
          cursor: pointer;
          position: relative;
          color: #9397a1;
          text-decoration: none;
          transition: color 0.2s ease, background-color 0.2s ease, padding-left 0.2s ease;
          overflow: hidden;
          padding-bottom: 1rem;

          i {
            opacity: 0;
            font-size: 20px;
          }

          &:last-child {
            padding-bottom: 0;
          }

          &:hover {
            color: #0b212d;
          }
        }

        .router-link-exact-active {
          color: #0b212d;
          font-family: "Neutrif-bold";

          i {
            opacity: 1;
          }
        }
      }

      .datepicker-customSelector {
        padding: 1.25rem 2rem;
        border-top: 1px solid #d7dce1;
        color: #9397a1;
        font-size: 16px;
        position: relative;

        a {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 16px;
          cursor: pointer;
          position: relative;
          color: #9397a1;
          text-decoration: none;
          transition: color 0.2s ease, background-color 0.2s ease, padding-left 0.2s ease;
          overflow: hidden;

          &:hover {
            color: #0b212d;
          }
        }
      }
    }

    .dropdown.open {
      transform: scale(1);
      opacity: 1;
      box-shadow: 3px 3px 30px rgba(0, 0, 0, 0.15);
    }
  }
}

// CARDS STYLING
.cards {
  display: flex;
  flex-wrap: wrap;

  .card {
    background-color: #fff;
    border-radius: $border-radius;
    border: 1px solid #d7dce1;
    height: 8rem;
    margin-right: 2rem;
    padding: 1.875rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 2rem;

    .card-title {
      font-size: 18px;
      color: #9397a1;
    }

    .card-data {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 24px;
      font-family: "Neutrif-bold";
      letter-spacing: 1px;

      i {
        color: #9397a1;
      }
    }
  }

  .card-wrapper {
    display: flex;
    justify-content: space-between;
    height: 100%;
    flex-direction: column;
  }
}

// CARDS STYLING MEDIA QUERIES
@media only screen and (max-width: 767px) {
  .cards {
    .card {
      margin-bottom: 1rem;
    }
  }
}

// DATEPICKER
.dp__input {
  height: 40px;
  border-radius: $border-radius !important;
  font-size: 14px !important;
  font-family: "Neutrif-reg" !important;
}

.dp__menu {
  padding: 1.25rem 2rem;
  box-shadow: 3px 3px 30px rgba(0, 0, 0, 0.15);
  border-radius: $border-radius;
  border: none;
  z-index: 999;
  margin-left: 2rem;

  .dp__arrow_top {
    border: none;
    box-shadow: 3px 3px 30px rgba(0, 0, 0, 0.15);
  }

  .dp__action_row {
    border-top: 1px solid #d7dce1;
    padding: 0;
    padding-top: 1.25rem;
  }

  .dp__cancel {
    margin-right: 1rem;
    text-transform: capitalize;
    color: #9397a1;
  }

  .dp__active_date,
  .dp__range_start,
  .dp__range_end {
    background: #3aafe3;
  }

  .dp__range_between {
    border: none;
  }

  .dp__today {
    border-color: #3aafe3;
  }

  .dp__select {
    height: 35px;
    background-color: #3aafe3;
    padding: 0 1rem;
    text-transform: capitalize;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    width: fit-content;
  }

  .dp__cell_disabled {
    color: #c0c4cc;
  }

  .dp__week_num {
    color: #c0c4cc !important;
  }

  .dp__calendar_item {
    color: #0b212d;
  }

  .dp__selection_preview {
    width: 30%;
  }

  .dp__action_buttons {
    width: 70%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .dp__calendar_header_separator {
    color: #d7dce1;
  }
}

// SELECTOR
#employees-select {
  .v-select.vs--open {
    .vs__open-indicator {
      margin-bottom: 4px;
    }
  }

  .v-select {
    .vs__dropdown-toggle {
      flex-direction: row-reverse;
      align-items: center;
      justify-content: center;
      padding: 20px 0;
      border: none;

      .vs__selected-options {
        .vs__search {
          padding: 0 15px;
          font-weight: bold;
          color: #9397a1;
        }
      }

      .vs__actions {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 30px;
        width: 30px;
        background-color: #3aafe3;
        border-radius: 100%;

        .vs__open-indicator {
          margin-left: 3px;
        }

        .vs__clear {
          margin-right: 12px;

          svg {
            margin-left: 18px;
            margin-bottom: 1px;
          }
        }

        svg {
          fill: white;
        }
      }

      .vs1__listbox {
        z-index: 999;
      }
    }

    .vs__dropdown-menu {
      box-shadow: 0px 0px 4px rgba(11, 33, 45, 0.15);
      margin-top: 2rem;
      left: calc(-2rem + 2px);
      width: calc(100% + (4rem - 4px));
      padding: 0;
    }
  }
}
</style>
